export default __webpack_public_path__ + "static/media/expRed.04b570c1.svg";